module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_6000.48fbb15c.png";